//  ----------      START   IMPORT  BLOCK       ----------
import { Modal } from 'react-bootstrap';
//  Context
import { useLanguage } from '../../../API/Context/LanguageContext';
//  Config
import colorPrescriptionInstructions from '../../../ConfigFiles/colors/color_prescription_instructions';
import VocabInstructionsPrescription from '../../../ConfigFiles/multilingual/VocabInstructionsPrescription';
import './prescription_instructions.css';
//  ----------      END   IMPORT  BLOCK       ----------


const PrescriptionInstructions = ({ show, onHide }) => {
    //  Consume context.
    const { lan } = useLanguage()

  //  Modal content.
  const modalContent = [
    { word: VocabInstructionsPrescription.numeration[lan], text: VocabInstructionsPrescription.numeration_description[lan] },

    { word: VocabInstructionsPrescription.drug[lan], text: VocabInstructionsPrescription.drug_description[lan] },
    { word: VocabInstructionsPrescription.hyphen[lan], text: VocabInstructionsPrescription.hyphen_description[lan] },
    { word: VocabInstructionsPrescription.verb[lan], text: VocabInstructionsPrescription.verb_description[lan] },

    { word: VocabInstructionsPrescription.number_drug[lan], text: VocabInstructionsPrescription.number_drug_description[lan] },
    { word: VocabInstructionsPrescription.unit_drug[lan], text: VocabInstructionsPrescription.unit_drug_description[lan] },

    { word: VocabInstructionsPrescription.conjunction[lan], text: VocabInstructionsPrescription.conjunction_description[lan] },

    { word: VocabInstructionsPrescription.number_peropdicity[lan], text: VocabInstructionsPrescription.number_peropdicity_description[lan] },
    { word: VocabInstructionsPrescription.peropdicity_unit[lan], text: VocabInstructionsPrescription.peropdicity_unit_description[lan] },

    { word: VocabInstructionsPrescription.route_of_administration[lan], text: VocabInstructionsPrescription.route_of_administration_description[lan] },

    { word: VocabInstructionsPrescription.preposition[lan], text: VocabInstructionsPrescription.preposition_description[lan] },

    { word: VocabInstructionsPrescription.number_duration[lan], text: VocabInstructionsPrescription.number_duration_description[lan] },
    { word: VocabInstructionsPrescription.unit_duration[lan], text: VocabInstructionsPrescription.unit_duration_description[lan] },

    { word: VocabInstructionsPrescription.semicolon[lan], text: VocabInstructionsPrescription.semicolon_description[lan] },

    { word: VocabInstructionsPrescription.indication_of_use[lan], text: VocabInstructionsPrescription.indication_of_use_description[lan] },
  ];
  //  Colors used for modal explanation.
  const tones = colorPrescriptionInstructions.colors_arr

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="centered-modal-title">
          {VocabInstructionsPrescription.instructions_prescription_tittle[lan]}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {/*   Instruction example   */}
          {VocabInstructionsPrescription.example_sentence_arr.map((subArray, subIndex) => (
            <div key={subIndex}>
              {/*   First element on its own line   */}
              {subIndex === 0 && subArray.length > 0 && (
                <p style={{ fontWeight: 'bold', color: tones[0], marginBottom: '0.5rem' }}>
                  {subArray[0]}
                </p>
              )}

              {/*   Remaining elements on the next line   */}
              <p style={{ marginBottom: '1rem' }}>
                {subArray.slice(1).map((word, wordIndex) => (
                  <span key={wordIndex} style={{ color: tones[wordIndex + 1], fontWeight: 'bold' }}>
                    {word}{' '}
                  </span>
                ))}
              </p>
            </div>
          ))}
        </div>
        <hr className="my-2" />
        {/*   Broken down text    */}
        {modalContent.map((item, index) => (
          <p key={index} style={{ margin: 0 }}>
            <span style={{ color: tones[index], fontWeight: 'bold' }}>{item.word}</span>
            <span style={{ color: 'black' }}>{item.text}</span>
          </p>
        ))}
        <hr className="my-2" />
        <p>{VocabInstructionsPrescription.note_on_quantitites[lan]}</p>
      </Modal.Body>
    </Modal>
  );
};

export default PrescriptionInstructions;
